import { useAnalysisFormStore } from '../../../model/analysisFormStore';
import { CreateManuallyTab } from '../shared';
import { useTranslation } from 'react-i18next';

export const CompetitorCreateManuallyTab = () => {
  const { t } = useTranslation('analysis');

  const entries = useAnalysisFormStore((s) => s.manualCompetitors);
  const onAdd = useAnalysisFormStore((s) => s.addManualCompetitor);
  const onUpdate = useAnalysisFormStore((s) => s.updateManualCompetitor);
  const onRemove = useAnalysisFormStore((s) => s.removeManualCompetitor);

  return (
    <CreateManuallyTab
      entries={entries}
      label={t('analysis.competitorCreateManuallyTab.competitor')}
      namePlaceholder={t('analysis.competitorCreateManuallyTab.eGNikeAdidasPuma')}
      detailsPlaceholder={t('analysis.competitorCreateManuallyTab.describeTheCompetitorSMarket')}
      addButtonLabel={t('analysis.competitorCreateManuallyTab.addCompetitor')}
      onAdd={onAdd}
      onUpdate={onUpdate}
      onRemove={onRemove}
    />
  );
};
